module.exports = __webpack_public_path__ + "media/icons/arrow-down-2@2x-d96f58c6.png";